//
// Force postcode input to be in uppercase
//
export default class ForceUppercaseInput {
  constructor() {
  }

  init() {
    // Check for the existance of any uppercase input fields
    this.uppercaseInputFields = document.querySelectorAll('.js-uppercase-input');
    if (!this.uppercaseInputFields) return;

    this.addEventHandling();
  }

  /**
   * @public
   */
  convertValueToUppercase(event) {
    // Get input
    let inputField = event.currentTarget;

    // Get selection start position
    let selectionPosition = inputField.selectionStart;
    // Convert to uppercase
    inputField.value = inputField.value.toUpperCase();
    // Keep selection position
    inputField.setSelectionRange(selectionPosition, selectionPosition);
  }

  addEventHandling() {
    this.uppercaseInputFields.forEach(uppercaseInputField => {
      uppercaseInputField.addEventListener('input', this.convertValueToUppercase.bind(this));
    });

  }
}